import React from 'react';
import { Typography, TypographyProps, Box, SxProps } from '@mui/material';

const boxStyles: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  minHeight: { xs: '84px', sm: '50px' },
  flexDirection: { xs: 'column', sm: 'row' },
  background:
    'linear-gradient(90deg, rgba(0, 166, 118, 0.4) 0%, rgba(1, 167, 159, 0.4) 100%)',
};

const typoProps: TypographyProps = {
  variant: 'subtitle1',
  textAlign: 'center',
  margin: '8px',
};

interface CompletedSubtopicsProps {
  completedSubTopics: number;
}

const SubTopicProgressBanner: React.FC<CompletedSubtopicsProps> = ({
  completedSubTopics,
}) => {
  const availableCount = 5 - completedSubTopics;

  return (
    <Box
      sx={{
        ...boxStyles,
        zIndex: 5,
        top: { xs: '56px', sm: '64px' },
      }}
    >
      {availableCount === 0 ? (
        <Typography {...typoProps}>
          Great job! 🎉 You&apos;ve completed 5 free sub-topics! Upgrade for
          unlimited learning! 🚀
        </Typography>
      ) : (
        <Typography {...typoProps}>
          You&apos;ve completed <strong>{completedSubTopics} of 5</strong> free
          sub-topics!{' '}
        </Typography>
      )}
    </Box>
  );
};

export default SubTopicProgressBanner;
